import Minimal from './Minimal.vue'

export default Minimal
